import { render, staticRenderFns } from "./EditDispatchLocation.vue?vue&type=template&id=5142886a&"
import script from "./EditDispatchLocation.vue?vue&type=script&lang=ts&"
export * from "./EditDispatchLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports